/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
import { ForeignParamsFragmentDoc } from './ForeignFragments'
import { CurrentUserFragmentDoc } from './My'
import { UiFragmentDoc } from './Ui'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type GQLForeignRootQueryVariables = Types.Exact<{
  userId: Types.Scalars['UserId']['input']
  hitType?: Types.InputMaybe<Types.Scalars['Int']['input']>
  limitCountries: Types.Scalars['Int']['input']
  limitInterest: Types.Scalars['Int']['input']
  authorized: Types.Scalars['Boolean']['input']
  giftsLimit: Types.Scalars['Int']['input']
}>

export type GQLForeignRootQuery = {
  __typename?: 'Query'
  user?: {
    __typename?: 'PublicProfile'
    id: any
    name: string
    age?: number | null
    gender: Types.GQLGender
    zodiacSign?: Types.GQLZodiacSign | null
    isBirthdayToday?: boolean | null
    incognito: boolean
    deleted: boolean
    compatibility?: number
    online?: { __typename?: 'Online'; status: boolean } | null
    location: {
      __typename?: 'Location'
      name: string
      city: { __typename?: 'City'; id: string; name: string }
      region: { __typename?: 'Region'; id: string; name: string }
      country: { __typename?: 'Country'; id: string; name: string }
    }
    verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
    relations: {
      __typename?: 'ProfileRelations'
      winkedByMe?: boolean
      contact?: {
        __typename?: 'ChatContact'
        contactId: any
        favorite: boolean
        ignoredByThem: boolean
      } | null
      spaceTimeLocation?: {
        __typename?: 'SpaceTimeLocationRelation'
        text: any
      } | null
      distance?: { __typename?: 'Distance'; text: any } | null
    }
    photos: {
      __typename?: 'ProfilePhotos'
      photosCount: number
      photos: {
        __typename?: 'PublicPhotosConnection'
        nodes: Array<{
          __typename?: 'Photo'
          main: boolean
          width: number
          height: number
          portrait: boolean
          verified: boolean
          voted: boolean
          voteable: boolean
          likes: number
          liked: boolean
          photoId: any
          urls: {
            __typename?: 'PhotoUrls'
            huge: string
            square: string
            squareLarge: string
            squareSmall: string
            xHuge?: string | null
          }
          faceCenter?: {
            __typename?: 'PhotoFaceCenter'
            xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
            huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          } | null
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
      default?: {
        __typename?: 'Photo'
        main: boolean
        width: number
        height: number
        portrait: boolean
        verified: boolean
        voted: boolean
        voteable: boolean
        likes: number
        liked: boolean
        photoId: any
        urls: {
          __typename?: 'PhotoUrls'
          huge: string
          square: string
          squareLarge: string
          squareSmall: string
          xHuge?: string | null
        }
        faceCenter?: {
          __typename?: 'PhotoFaceCenter'
          xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
        } | null
      } | null
    }
    travelAtlas: {
      __typename?: 'PublicTravelAtlas'
      visitedCountries: {
        __typename?: 'PublicTravelAtlasVisitedCountries'
        visitedCountriesCount: number
        visitedCountries: {
          __typename?: 'PublicTravelAtlasVisitedCountriesConnection'
          nodes: Array<{
            __typename?: 'PublicTravelAtlasVisitedCountry'
            date: string
            country: {
              __typename?: 'Country'
              id: string
              name: string
              code: string
              isoCode: string
            }
          }>
          pageInfo: {
            __typename?: 'PageInfo'
            hasNextPage: boolean
            endCursor: any
          }
        }
      }
      badges: {
        __typename?: 'PublicTravelAtlasBadges'
        badgesCount: number
        badges: {
          __typename?: 'PublicTravelAtlasBadgesConnection'
          nodes: Array<{
            __typename?: 'PublicTravelAtlasBadge'
            id: number
            name: string
            desc: string
            image: string
          }>
          pageInfo: {
            __typename?: 'PageInfo'
            hasNextPage: boolean
            endCursor: any
          }
        }
      }
    }
    vip: {
      __typename?: 'Vip'
      active: boolean
      presentVip?: {
        __typename?: 'PublicPresentVip'
        days: number
        hidden: boolean
        presenter?: {
          __typename?: 'PublicProfile'
          id: any
          name: string
          gender: Types.GQLGender
          age?: number | null
          online?: {
            __typename?: 'Online'
            status: boolean
            description: any
          } | null
          verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
          location: { __typename?: 'Location'; name: string }
          photos: {
            __typename?: 'ProfilePhotos'
            default?: {
              __typename?: 'Photo'
              id: any
              urls: {
                __typename?: 'PhotoUrls'
                squareSmall: string
                square: string
                squareLarge: string
                huge: string
              }
            } | null
          }
        } | null
      } | null
    }
    dating: {
      __typename?: 'PublicDatingProfile'
      aboutMe: string
      lookFor: Array<Types.GQLLookFor>
      datingGoals?: Array<Types.GQLDatingGoals> | null
      knownLanguages?: Array<any> | null
      height?: number | null
      weight?: number | null
      orientation?: Types.GQLOrientation | null
      children?: Types.GQLChildren | null
      education?: Types.GQLEducation | null
      appearance?: Types.GQLAppearance | null
      constitution?: Types.GQLConstitution | null
      alcohol?: Types.GQLAlcoholAttitude | null
      smoking?: Types.GQLSmokingAttitude | null
      homeStatus?: Types.GQLHomeStatus | null
      materialStatus?: Types.GQLMaterialStatus | null
      lookForAge: { __typename?: 'AgeRange'; from: number; to: number }
    }
    sharing?: {
      __typename?: 'PublicSharing'
      widgets?: {
        __typename?: 'PublicWidgets'
        thisIsMe?: { __typename?: 'ThisIsMeWidget'; url: string } | null
      } | null
    } | null
    interests: {
      __typename?: 'PublicInterests'
      interestsCount: number
      interests: {
        __typename?: 'PublicInterestsConnection'
        nodes: Array<{
          __typename?: 'PublicInterest'
          interestId: number
          text: string
          matchMy?: boolean | null
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
    }
    gifts: {
      __typename?: 'Gifts'
      giftsCount: number
      gifts: {
        __typename?: 'GiftsConnection'
        nodes: Array<{
          __typename?: 'Gift'
          giftId: number
          message: string
          senderHidden: boolean
          my: boolean
          senderProfile?: {
            __typename?: 'PublicProfile'
            id: any
            name: string
            age?: number | null
            gender: Types.GQLGender
            deleted: boolean
            photos: {
              __typename?: 'ProfilePhotos'
              default?: {
                __typename?: 'Photo'
                id: any
                urls: { __typename?: 'PhotoUrls'; square: string }
              } | null
            }
            online?: { __typename?: 'Online'; status: boolean } | null
            relations: {
              __typename?: 'ProfileRelations'
              spaceTimeLocation?: {
                __typename?: 'SpaceTimeLocationRelation'
                text: any
              } | null
            }
            verification: {
              __typename?: 'Verification'
              verifiedPhotos: boolean
            }
          } | null
          image: {
            __typename?: 'MyGiftImage'
            name: string
            formats: Array<number>
          }
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          endCursor: any
          hasNextPage: boolean
        }
      }
    }
    teamo?: {
      __typename?: 'PublicTeamo'
      compatibility?: number | null
      surveyResult?: Array<{
        __typename?: 'TeamoPeculiarity'
        id: number
        points: number
        title: string
        description: string
      }> | null
    } | null
  } | null
  my?: {
    __typename?: 'My'
    interests: {
      __typename?: 'MyInterests'
      interestsCount: number
      interests: {
        __typename?: 'MyInterestsConnection'
        nodes: Array<{
          __typename?: 'MyInterest'
          interestId: number
          text: string
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
    }
    travelAtlas: {
      __typename?: 'MyTravelAtlas'
      visitedCountries: {
        __typename?: 'MyTravelAtlasVisitedCountries'
        visitedCountriesCount: number
        visitedCountries: {
          __typename?: 'MyTravelAtlasVisitedCountriesConnection'
          nodes: Array<{
            __typename?: 'MyTravelAtlasVisitedCountry'
            visible: boolean
            country: {
              __typename?: 'Country'
              id: string
              code: string
              isoCode: string
              name: string
            }
          }>
        }
      }
    }
    teamo?: {
      __typename?: 'MyTeamo'
      surveyResults?: Array<{
        __typename?: 'TeamoPeculiarity'
        id: number
        points: number
        title: string
        description: string
      }> | null
    } | null
  }
  ui: {
    __typename?: 'Ui'
    glossary: {
      __typename?: 'LexicalGlossary'
      datingProfile: {
        __typename?: 'DatingProfileLexicalDictionary'
        alcohol: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        appearance: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        children: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        constitution: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        datingGoals: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        education: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        homeStatus: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        knownLanguages: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        lookFor: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        materialStatus: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        orientation: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
        smoking: Array<{
          __typename?: 'DatingProfileLexicalOptionType'
          value?: string | null
          lexeme?: string | null
          maleLexeme?: string | null
          femaleLexeme?: string | null
        }>
      }
    }
    giftFormats: Array<{
      __typename?: 'GiftImageFormatType'
      formatId: number
      urlTemplate: string
      type: Types.GQLGiftImageKind
    }>
  }
}

export const ForeignRootDocument = gql`
  query ForeignRoot(
    $userId: UserId!
    $hitType: Int
    $limitCountries: Int!
    $limitInterest: Int!
    $authorized: Boolean!
    $giftsLimit: Int!
  ) {
    ...ForeignParams
    ...CurrentUser
    ...Ui
  }
  ${ForeignParamsFragmentDoc}
  ${CurrentUserFragmentDoc}
  ${UiFragmentDoc}
`

/**
 * __useForeignRootQuery__
 *
 * To run a query within a React component, call `useForeignRootQuery` and pass it any options that fit your needs.
 * When your component renders, `useForeignRootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForeignRootQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      hitType: // value for 'hitType'
 *      limitCountries: // value for 'limitCountries'
 *      limitInterest: // value for 'limitInterest'
 *      authorized: // value for 'authorized'
 *      giftsLimit: // value for 'giftsLimit'
 *   },
 * });
 */
export function useForeignRootQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQLForeignRootQuery,
    GQLForeignRootQueryVariables
  > &
    (
      | { variables: GQLForeignRootQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQLForeignRootQuery, GQLForeignRootQueryVariables>(
    ForeignRootDocument,
    options
  )
}
export function useForeignRootLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQLForeignRootQuery,
    GQLForeignRootQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GQLForeignRootQuery, GQLForeignRootQueryVariables>(
    ForeignRootDocument,
    options
  )
}
export function useForeignRootSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQLForeignRootQuery,
        GQLForeignRootQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQLForeignRootQuery,
    GQLForeignRootQueryVariables
  >(ForeignRootDocument, options)
}
export type ForeignRootQueryHookResult = ReturnType<typeof useForeignRootQuery>
export type ForeignRootLazyQueryHookResult = ReturnType<
  typeof useForeignRootLazyQuery
>
export type ForeignRootSuspenseQueryHookResult = ReturnType<
  typeof useForeignRootSuspenseQuery
>
export type ForeignRootQueryResult = Apollo.QueryResult<
  GQLForeignRootQuery,
  GQLForeignRootQueryVariables
>
